import widgetIsPresent from '../../utils/widgetIsPresent';

export const DDC_INVENTORY_TYPEDSEARCH = 'ddc.inventory.typedSearch';

function typedSearch(
	{
		DDC: {
			dataLayer: {
				page,
				page: {
					attributes: { vehicleResultCount } = {},
					pageInfo: { isVlp, pageName, pageWidgets } = {}
				}
			},
			getUrlParams
		}
	},
	{ currentTarget: element } = {}
) {
	let eventObject;
	let { queryFacets } = page;
	let search = queryFacets?.search ? queryFacets.search : null;
	const isNoResults = pageName?.indexOf('NO_RESULTS') > -1;
	const resultCount = isNoResults ? '0' : vehicleResultCount;

	// If 'search' is not in queryFacets, we may be on a NO_RESULTS page. In that case, try to get the search
	// string from the request's query parameters (which are already in the data layer object).
	if (!search && isNoResults) {
		queryFacets = queryFacets || {};
		search = getUrlParams()?.search;
		queryFacets.search = getUrlParams()?.search;
	}

	if (
		search &&
		(isVlp ||
			isNoResults ||
			// When checking for the inventory listing widget, exclude the 'blank' version
			widgetIsPresent(/\.inventory-listing\.(?!blank)/, pageWidgets))
	) {
		eventObject = {
			eventType: DDC_INVENTORY_TYPEDSEARCH,
			eventData: {
				element,
				resultCount,
				queryFacets
			}
		};
	}

	return eventObject;
}

export default typedSearch;
